let pending: Promise<typeof import("./HomePageV2")> | undefined;

/** Preloading and the selected page share a download, never an exposure. */
export function loadHomePageV2(): Promise<typeof import("./HomePageV2")> {
  if (!pending) {
    pending = import("./HomePageV2").catch(error => {
      pending = undefined;
      throw error;
    });
  }
  return pending;
}
